import { action, observable } from 'mobx';
import Alert from 'react-s-alert';
import i18next from 'i18next';

import { AppManager, Input, App } from 'core/index';
import { routerStore } from 'core/routing';

import { FormStore } from 'libs/forms/app';

import { modalStore } from 'apps/modals/app';

import { NewPassWordMutation } from 'apps/signIn/gql';
import SignInModal from 'apps/signIn/main/modal';
import { conf } from 'apps/signIn/config.yaml';

class NewPasswordApp extends App {
  static registryName = 'NewPasswordApp';
  @observable newPassword = '';
  init() {
    this.form = new FormStore(this, conf, 'newPasswordForm');
  }

  @action Submit = () => {
    this.manager.Submit({
      onSysErr: this.onError,
      onUserErr: this.onError,
      onSuccess: this.onSuccess,
    });
  };

  @action onError = () => {
    Alert.error(
      i18next.t('We failed to change your password. Please try again'),
    );
  };

  @action onSuccess = result => {
    const { username } = this.manager.input;
    if (result.result === 'ok') {
      routerStore.router.navigate('home');
      modalStore.SetModalComponent(SignInModal);
      setTimeout(() => {
        Alert.success(
          i18next.t('Done! You can now sign in with your new password.'),
        );
      }, 600);
    } else if (result.result === 'fail') {
      if (result.msg === 'expired') {
        Alert.error(
          i18next.t(
            'This reset password link has expired. Please request a new one.',
          ),
        );
      } else if (result.msg === 'invalid') {
        Alert.error(
          i18next.t(
            "Sorry, you don't seem to be authorised to change {{username}}'s password.",
            { username },
          ),
        );
      }
    }
  };
}

export class NewPasswordFormAppManager extends AppManager {
  static registryName = 'NewPasswordFormAppManager';
  constructor(parent, init = {}) {
    super(parent, init);
    this.app = new NewPasswordApp(this, {});
    this.app.init();
    this.input = new Input({
      username: () => this.params.get('username'),
      expiryTime: () => this.params.get('expiry'),
      hmac: () => this.params.get('hmac'),
      newPassword: () => this.app.newPassword,
    });
  }

  @action Submit = options => {
    this.mutations.push(NewPassWordMutation.New(this.input, options));
  };
}
